import { Icon } from '../Icon'
import { AppTourLink } from '../AppTourLink'
import { OrganizationSwitcher } from '../OrganizationSwitcher'
import { headerStrings } from '../../constants/strings'
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard'

type HeaderProps = {
  email?: string
  organizationName?: string
  entryUrl?: string
}

export function Header({ email, organizationName, entryUrl }: HeaderProps) {
  const avatarLabel = email?.trim().charAt(0)
  const { status: copyStatus, copy } = useCopyToClipboard()

  return (
    <header className="sticky top-0 z-20 hidden border-b border-white/70 bg-white/80 px-5 py-3 backdrop-blur-md sm:px-6 lg:block lg:px-10">
      <div className="flex w-full flex-wrap items-center gap-3 lg:flex-nowrap">
        {organizationName && (
          <div className="flex min-w-0 flex-1 items-center gap-3 lg:flex-none">
            <OrganizationSwitcher
              variant="desktop"
              organizationName={organizationName}
            />
            {entryUrl && (
              <>
              <button
                type="button"
                onClick={() => copy(entryUrl)}
                aria-label={headerStrings.copyEntryUrl}
                className="inline-flex shrink-0 items-center gap-1.5 rounded-[var(--btn-radius)] bg-accent px-4 py-2 text-xs font-semibold text-white shadow-accent transition hover:-translate-y-0.5 hover:bg-accent-mid hover:shadow-accent-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
              >
                {copyStatus === 'success' ? (
                  <>
                    <Icon icon="check" className="h-3.5 w-3.5" />
                    <span>{headerStrings.copyEntryUrlSuccess}</span>
                  </>
                ) : copyStatus === 'error' ? (
                  <span>{headerStrings.copyEntryUrlError}</span>
                ) : (
                  <>
                    <Icon icon="link" className="h-3.5 w-3.5" />
                    <span>{headerStrings.copyEntryUrl}</span>
                  </>
                )}
              </button>
              <span aria-live="polite" className="sr-only">
                {copyStatus === 'success' ? headerStrings.copyEntryUrlSuccess : copyStatus === 'error' ? headerStrings.copyEntryUrlError : ''}
              </span>
              </>
            )}
          </div>
        )}
        <div className="ml-auto flex items-center gap-3">
          <AppTourLink />
          <div className="flex items-center gap-3 rounded-[var(--btn-radius)] border border-border/70 bg-white/80 px-3 py-1.5 text-left shadow-sm">
            <span className="grid h-9 w-9 place-items-center rounded-full bg-ink text-xs font-semibold text-white">
              {avatarLabel}
            </span>
            {email && (
              <span className="hidden min-w-0 truncate text-xs font-semibold text-ink sm:block">
                {email}
              </span>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}
